var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-label',_vm._b({staticClass:"b-label-onair",attrs:{"color":"red","text-color":"white--text"}},'b-label',_vm.$attrs,false),[_c('v-icon',{attrs:{"size":"14","color":"white"}},[_vm._v("mdi-broadcast")]),_vm._v("\n  On Air\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }